import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const PopupWrapper = styled.div`
  position: absolute;
  right: -${pxToRem('40px')};
  top: ${pxToRem('60px')};
  width: ${pxToRem('194px')};
  height: ${pxToRem('144px')};
  border-radius: ${pxToRem('8px')};
  box-shadow: 0 ${pxToRem('12px')} ${pxToRem('24px')} ${pxToRem('8px')}
    ${props => props.theme.colors.blue.six};
  border: solid ${pxToRem('1px')} ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.white};

  display: flex;
  flex-direction: column;

  z-index: 100;
  justify-content: space-around;
  margin-right: ${pxToRem('40px')};

  padding: ${pxToRem('18px')} ${pxToRem('8px')};
`;

export const ListItem = styled.div`
  padding: ${pxToRem('15px')};
  text-align: center;
  border-radius: ${pxToRem('10px')};
  display: flex;
  font-weight: 500;
  justify-content: flex-start;
  :hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.blue.five};
    font-weight: 600;
  }
`;

export const IconWrapper = styled.div`
  font-size: ${pxToRem('20px')};
  line-height: ${pxToRem('25px')};
  margin-right: ${pxToRem('26px')};
`;
